import './App.css';
import { BrowserRouter as Router, useRoutes, Routes, Route, Link, Navigate, Outlet, useNavigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import store from './redux/store';
import { IntlProvider } from 'react-intl';
import { CookiesProvider } from 'react-cookie';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { withNamespaces } from 'react-i18next'
import i18n from './i18n'
import { GOOGLE_OAUTH_CLIENT_ID, GOOGLE_OAUTH_CLIENT_SECRET } from "./constants";


import ClinicHome from './page1s/Home';
import ClinicDepartment from './page1s/Home/Department';
import ClinicDoctor from './page1s/Home/Doctor';
import ClinicViewPatientTicket from './page1s/Home/ViewPatientTicket';
import ClinicServicePrices from './page1s/Home/ServicePrices';
import ClinicViewSchedule from './page1s/Home/ViewSchedule';
import ClinicDisplayPatientResult from './page1s/Home/DisplayPatientResult';
import ClinicUserInformation from './page1s/Home/Users/UserInformation';
import ClinicInformation from './page1s/Home/Users/ClinicInformation';
import ClinicChangePassword from './page1s/Home/Users/ChangePassword';
import ClinicForgotPassword from './page1s/Home/Users/ForgotPassword';
import ClinicSettings from './page1s/Home/Settings';

import _404Page from './components/404Page';

// import AuthProvider from './page1s/Auth';
import ProtectedRoute from './page1s/Auth/ProtectedRoute';
import Login from './page1s/Auth/Login';
import CreateNewUser from './page1s/Auth/CreateNewUser';
import Pricing from './page1s/Home/Pricing';
import PaymentResponse from './page1s/Home/Payments/PaymentResponse';

const customTheme = extendTheme({
  fonts: {
      heading: 'Helvetica Neue, sans-serif',
      body: 'Quicksand'
  }
});

// function App ({ t }) {
//   console.log("--- t", t('Welcome to React'))
//   console.log("--- i18n", i18n)
//   const changeLanguage = (lng) => {
//     i18n.changeLanguage(lng);
//   }

//   return (
//     <div>
//       <button onClick={() => changeLanguage('de')}>de</button>
//       <button onClick={() => changeLanguage('en')}>en</button>
//       <h1>{t('Welcome to React')}</h1>
//     </div>
//   )
// }

function App({ t }) {
  return (
    <Provider store={store}>
      <CookiesProvider>
        <ChakraProvider theme={customTheme}>
          <IntlProvider locale='vi'>
            <GoogleOAuthProvider clientId={GOOGLE_OAUTH_CLIENT_ID}>
              <Router>
                {/* <AuthProvider> */}
                  <Routes>
                      <Route path='/' element={<ClinicHome />} />
                      <Route path='/department' element={<ClinicDepartment />} />
                      <Route path='/doctor' element={<ClinicDoctor />} />
                      <Route path='/view_patient_ticket' element={<ClinicViewPatientTicket />} />
                      <Route path='/service_prices' element={<ClinicServicePrices />} />
                      <Route path='/view_schedule' element={<ClinicViewSchedule />} />
                      <Route path='/display_result/:encrypt_url' element={<ClinicDisplayPatientResult />} />
                      <Route element={<ProtectedRoute />}>
                        <Route path='/user_information' element={<ClinicUserInformation />} />
                        <Route path='/clinic_information' element={<ClinicInformation />} />
                        <Route path='/change_password' element={<ClinicChangePassword />} />
                        <Route path='/settings' element={<ClinicSettings />} />
                      </Route>
                      <Route path='/login' element={<Login />} />
                      <Route path='/create_new_user/:register_code' element={<CreateNewUser />} />
                      <Route path='/forgot_password/:forgot_password_code' element={<ClinicForgotPassword />} />
                      <Route path='/pricing/new' element={<Pricing />} />
                      <Route path='/pricing/extend/:company_id' element={<Pricing />} />
                      <Route path='/payment_response/:payment_type/:payment_status' element={<PaymentResponse />} />
                    <Route path='/*' element={<_404Page />} />
                  </Routes>
                {/* </AuthProvider> */}
              </Router>
            </GoogleOAuthProvider>
          </IntlProvider>
        </ChakraProvider>
      </CookiesProvider>
    </Provider>
  );
}

export default withNamespaces()(App);